
const HOURS_LIMIT = 72;
const MS_LIMIT = HOURS_LIMIT * 60 * 60 * 1000;
const TS_KEY = 'amazonCheckoutTimestamp';

async function maybeClearExpiredCart() {
    const ts = localStorage.getItem(TS_KEY);
    if (!ts) return;

    if (Date.now() - Number(ts) > MS_LIMIT) {
        await fetch('/cart/clear.js', { method: 'POST' });
        localStorage.removeItem(TS_KEY);

        if (typeof window.updateMiniCart === 'function') {
            window.updateMiniCart();
        } else if (window.Shopify && Shopify.getCart) {
            Shopify.getCart(() => document.dispatchEvent(new Event('cart:updated')));
        }
    }
}

document.addEventListener('DOMContentLoaded', maybeClearExpiredCart);

document.addEventListener('click', (e) => {
    if (e.target.closest('#amazon-checkout')) {
        localStorage.setItem(TS_KEY, Date.now().toString());
    }
});